
import { useQuery } from '@tanstack/react-query';
import { useApiClient } from '../../../apiClient';
import { UserMembershipDto } from '../../../models/user-membership/dto/user-membership.dto';
import { GET_USER_BY_ID_QUERY_KEY } from './useGetUser';

export const GET_USER_MEMBERSHIPS_QUERY_KEY = (userId: string) => [...GET_USER_BY_ID_QUERY_KEY(userId), 'memberships']
export const useGetUserMemberships = (userId: string) => {
    const apiClient = useApiClient();
    return useQuery({
        queryKey: GET_USER_MEMBERSHIPS_QUERY_KEY(userId),
        queryFn: async () => {
            const response = await apiClient.fetchApi<UserMembershipDto[], {}>({ method: 'GET', endpoint: `users/${userId}/memberships` });
            return response
        },
        // MYSPORTSET-API-EC: without this the hook fired `users/null/memberships`
        // (template-literal stringification) whenever userId was not yet
        // resolved, crashing the API with a 500 on every render.
        enabled: Boolean(userId),
    });
};